import { Controller } from "@hotwired/stimulus"
import Tribute from "tributejs"

export default class extends Controller {
  static targets = [ "field" ]

  connect() {
    this.boundTrixInit = this.trixInitialized.bind(this)

    // If Trix is already initialized (e.g. reconnect after Turbo morph), use it directly
    if (this.fieldTarget.editor) {
      this.editor = this.fieldTarget.editor
      this.initializeTribute()
    } else {
      // Wait for Trix to initialize on this element
      this.fieldTarget.addEventListener("trix-initialize", this.boundTrixInit, { once: true })
    }
  }

  trixInitialized() {
    this.editor = this.fieldTarget.editor
    if (this.editor) {
      this.initializeTribute()
    }
  }

  disconnect() {
    if (this.boundTrixInit) {
      this.fieldTarget.removeEventListener("trix-initialize", this.boundTrixInit)
    }
    if (this.tribute) {
      this.tribute.detach(this.fieldTarget)
    }
  }

  initializeTribute() {
    // Find the closest dialog ancestor so the menu renders inside modals
    const dialog = this.fieldTarget.closest("dialog")
    const menuContainer = dialog || document.body

    this.tribute = new Tribute({
      trigger: '@',
      allowSpaces: false,
      lookup: 'mention_handle',
      fillAttr: 'mention_handle',
      values: (text, callback) => {
        if (this.users) {
          callback(this.users)
        } else {
          fetch("/mentions.json")
            .then(response => response.json())
            .then(users => {
              this.users = users
              callback(users)
            })
            .catch(() => callback([]))
        }
      },
      containerClass: 'tribute-container z-50',
      positionMenu: true,
      menuContainer: menuContainer,
      menuShowMinLength: 0,
      menuItemLimit: 10,
      noMatchTemplate: '<li class="px-2 py-1 text-gray-400 text-sm">No matches</li>',
      menuItemTemplate: function (item) {
        return `<span class="tribute-mention-item">@${item.original.mention_handle} <span class="text-gray-400">[${item.original.reference_name}]</span><span class="tribute-mention-email">${item.original.email}</span></span>`
      }
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener("tribute-replaced", this.replaced.bind(this))
  }

  replaced(e) {
    let mention = e.detail.item.original
    const attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content,
      contentType: "mention"
    })
    this.editor.insertAttachment(attachment)
  }

  _pasteHtml(html, startPos, endPos) {
    let position = this.editor.getPosition()
    let tributeLength = endPos - startPos
    let trixStartPos = position - tributeLength
    let trixEndPos = position
    this.editor.setSelectedRange([trixStartPos, trixEndPos])
    this.editor.deleteInDirection("backward")
  }
}
